import { render, staticRenderFns } from "./VirtualAssistSummary.vue?vue&type=template&id=5a8eac1c&scoped=true"
import script from "./VirtualAssistSummary.vue?vue&type=script&lang=ts"
export * from "./VirtualAssistSummary.vue?vue&type=script&lang=ts"
import style0 from "./VirtualAssistSummary.vue?vue&type=style&index=0&id=5a8eac1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8eac1c",
  null
  
)

export default component.exports